import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const textPlugin = createPluginFromSingleComponentPlugin({
    name: 'TextPlugin',
    components: new Set([
        'MenuButton',
        'MediaRichText',
        'VKShareButton',
        'WRichText',
        'TextOption',
        'MobileTextOption',
        'ColorOption',
        'MobileColorOption',
        'QuickActionBarItem',
        'MobuiText',
        'CollapsibleText',
        'TextMask',
        'DashboardHeading',
        'DashboardText',
        'WbuLeftTextButton',
        'WutBadge'
    ]),
    pack,
    unpack
})
